import React from 'react';
import { Trans } from 'react-i18next';
import { getDomainConfig } from '../../lib/domainConfig';
import styles from './ConfirmCheckoutDisclaimer.module.scss';

export default function ConfirmCheckoutDisclaimer() {
  const { baseDomain } = getDomainConfig();
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  const linkComponent = <a href={`https://${baseDomain}/tos`} target="_blank" rel="noopener noreferrer" />;

  return (
    <div className={styles.container}>
      <Trans
        i18nKey="by_clicking_place_order_you_agree_to_our_terms_and_conditions"
        components={{
          tosLink: linkComponent,
        }}
      />
    </div>
  );
}
